<template>
  <div class="container">
    <div class="main">
      <!-- 轮播 -->
      <div class="swiper">
        <swiper class="slider" :options="options">
          <swiper-slide v-for="(item,index) in vacantShop.images" :key="index">
            <img :src="item.imageUrl" class="slide_image" @click="viewBigPic(item.imageUrl)" />
          </swiper-slide>
          <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
      </div>
      <!-- 头部信息 -->
      <div class="head_mess">
        <div class="head_price_Div">
            <p  :class="[ 'head_price_Div_text0',$store.state.common.theme!=3?'':'head_price_Div_text_theme_3' ]" >{{"￥"}}</p>
            <p  :class="[ 'head_price_Div_text1',$store.state.common.theme!=3?'':'head_price_Div_text_theme_3' ]">{{vacantShop.zjbz?vacantShop.zjbz:''}}</p>
            <span class="head_price_Div_text2">{{vacantShop.zjbzUnit |zjbzUnitFilters}}</span>
        </div>
        <div :class="['head_mess_title',vacantShop.label?'':'no_labal']">
          <p class="head_mess_title_text">{{vacantShop.title?vacantShop.title:''}}</p>
        </div>
        <div class="head_mess_labal" v-if="vacantShop.label">
          <span class="labal_item" v-for="(item,index) in vacantShop.label" :key="index"># {{item}}</span>
        </div>
        <div class="head_mess_address" v-if="vacantShop.address">
          <img v-if="$store.state.common.theme !=3" class="head_mess_address_icon" src="../../assets/images/icon_site.png" />
          <img v-if="$store.state.common.theme ==3" class="head_mess_address_icon" src="../../assets/images/themes_icon/icon_site_3.png" />
          <span class="head_mess_address_text">{{vacantShop.address}}</span>
          <img v-if="$store.state.common.theme !=3"
            class="btn_duplicate"
            @click="copyTradeCode"
            :data-clipboard-text="vacantShop.address"
            src="../../assets/images/btn_duplicate.png"
          />
          <img v-if="$store.state.common.theme ==3"
            class="btn_duplicate"
            @click="copyTradeCode"
            :data-clipboard-text="vacantShop.address"
            src="../../assets/images/themes_icon/btn_duplicate_3.png"
          />
        </div>
        <img v-if="$store.state.common.theme !=3" @click="shareFun" class="fengxiangIcon"  src="../../assets/images/icon_share.png"/>
        <img v-if="$store.state.common.theme ==3" @click="shareFun" class="fengxiangIcon"  src="../../assets/images/themes_icon/icon_share_3.png"/>
        <!-- <div class="infoAbsoulte">
          (元/㎡/天)
          <p class="infoAbsoulte_text1">租金</p>
          <p class="infoAbsoulte_text2">{{vacantShop.zjbz?vacantShop.zjbz:''}}</p>
        </div> -->
      </div>
      <!-- 基本信息 -->
      <div class="content_2">
        <p class="content_info_title">基本信息</p>
        <div class="frame_item">
          <div class="frame_item_1">
            <span class="frame_text1">楼栋名称</span>
            <span class="frame_text2">{{vacantShop.ldmc?vacantShop.ldmc:''}}</span>
          </div>
        </div>
        <div class="frame_item">
          <div class="frame_item_1">
            <span class="frame_text1">楼层名称</span>
            <span class="frame_text2">{{vacantShop.lcmc?vacantShop.lcmc:''}}</span>
          </div>
          <div class="frame_item_1">
            <span class="frame_text1">物管费</span>
            <!-- 元/月/㎡ -->
            <span class="frame_text2">{{vacantShop.wgbz?vacantShop.wgbz:''}}{{vacantShop.wgbzUnit |zjbzUnitFilters}}</span>
          </div>
        </div>
        <div class="frame_item">
          <div class="frame_item_1">
            <span class="frame_text1">单元号</span>
            <span class="frame_text2">{{vacantShop.dyh?vacantShop.dyh:''}}</span>
          </div>
          <div class="frame_item_1">
            <span class="frame_text1">单元类型</span>
            <span class="frame_text2">{{vacantShop.dylx?vacantShop.dylx:''}}</span>
          </div>
        </div>
        <div class="frame_item">
          <div class="frame_item_1">
            <span class="frame_text1">计租面积</span>
            <span class="frame_text2">{{vacantShop.jzmj?vacantShop.jzmj:''}}㎡</span>
          </div>
          <div class="frame_item_1">
            <!-- 先隐藏 -->
            <!-- <span class="frame_text1">建筑面积</span>
            <span class="frame_text2">{{vacantShop.jizmj?vacantShop.jizmj:''}}㎡</span> -->
          </div>
        </div>
        <div class="content_1_line"></div>
      </div>
      <div class="content_3">
        <div class="headePic">
          <img
            class="headePic_url"
            :src="item.userImage?item.userImage:require(`../../assets/images/img_default_face_${common.theme}.jpg`)"
            v-for="(item,index) in watchUsers"
            :key="index"
            v-if="index<8"
          />
        </div>
        <p class="content_3_text1">{{vacantShop.viewNum?vacantShop.viewNum:''}}人围观</p>
      </div>
      <div class="content_4" v-if="vacantShop.descr">
        <p class="content_4_text1">{{vacantShop.descr}}</p>
      </div>
    </div>
    <div class="btn">
      <div class="btn_phone_wrap">
        <img class="btn_phone_wrap_left" :src="require(`../../assets/images/img_default_face_${common.theme}.jpg`)" />
        <div class="btn_phone_wrap_right">
          <p class="wrap_right_text1">{{vacantShop.contactName?vacantShop.contactName:''}}</p>
          <p class="wrap_right_text2">{{vacantShop.contactPhone?vacantShop.contactPhone:''}}</p>
        </div>
      </div>

      <a  :class="[ 'btn_text_wrap',$store.state.common.theme!=3?'':'btn_text_wrap_theme_3' ]" :href="'tel:'+vacantShop.contactPhone" :phone="vacantShop.contactPhone">
        <img class="btn_icon" :src="require(`../../assets/images/themes_icon/icon_iphone_${common.theme}.png`)" />
        <span :class="[ 'btn_text', $store.state.common.theme!=3?'':'btn_text_theme_3'  ]"  >立即咨询</span>
      </a>
    </div>
    <!-- 查看大图 -->
    <fade-animation>
      <common-gallary :imgs="imgs" :curIndex="curIndex" v-show="showGallary" @close="handleGallaryClose"></common-gallary>
    </fade-animation>
    <share-iframe :showIframe="showIframe" @hideIframe="hideIframe"></share-iframe>
  </div>
</template>

<script>
import util from "../../utils/util";
import { mapState } from "vuex";
import { getDetailById } from "../../utils/api";
import CommonGallary from "../../components/Gallary";
import FadeAnimation from "../../components/FadeAnimation";
import ShareIframe from '../../components/shareIframe';
import Clipboard from "clipboard";
import wx from 'weixin-js-sdk'
//import wx from 'jweixin-1.6.0'
export default {
  name: "emptyShopList",
  data() {
    return {
      id: "",
      watchUsers: [],
      vacantShop: {},
      showGallary:false,
      showIframe:false,
      imgs:[],
      curIndex:0,
      options: {
        pagination: ".swiper-pagination",
        paginationType: "fraction",
        observeParents: true,
        autoplay: 3000,
        speed: 1000,
        observer: true
      }
    };
  },
  components: {
    CommonGallary,
    FadeAnimation,
    ShareIframe
  },
  computed: {
    ...mapState({
      common: state => state.common
    })
  },
  filters:{
    zjbzUnitFilters(status){
      switch (status) {
         case 1:
           return '元/㎡/天';
         case 2:
           return '元/天';
         case 3:
           return '元/月';
         case 4:
           return '元/㎡/月';
         default:
           return '';
       }
    }
  },
  created() {
    this.id = this.$route.query.id;
    this.getDetailById();
  },
  methods: {
     shareFun(){
      this.showIframe = true
    },
    hideIframe(){
      this.showIframe = false
    },
    handleGallaryClose() {
      this.showGallary = false;
    },
    viewBigPic(imgPath) {
      this.imgs.forEach((item,index)=>{
        if(item === imgPath){
          this.curIndex = index
          this.showGallary = true
        }
      })
    },
    copyTradeCode() {
      var clipboard = new Clipboard(".btn_duplicate");
      clipboard.on("success", () => {
        util.showToast("复制成功");
        // 释放内存
        clipboard.destroy();
      });
    },
    getDetailById() {
      var that =this;
      let params = {
        id: this.id
      };
      getDetailById(params).then(res => {
        console.log(res);
        if (res.res.code === 10000) {
          if (res.body) {
            let data = res.body.vacantShop;
            if (data.label) {
              data.label = data.label.split(",");
            }
            this.watchUsers = res.body.watchUsers;
            this.vacantShop = res.body.vacantShop;
            if(this.vacantShop.images && this.vacantShop.images.length){
              this.imgs = []
              this.vacantShop.images.forEach(item=>{
                this.imgs.push(item.imageUrl)
              })
            }
          }
          let address = window.location.href.split('?')[0];
           wx.ready(()=>{
            let obj = {
                title: that.vacantShop.title, // 分享标题
                desc:'面积:'+that.vacantShop.jzmj+'㎡;地址:'+that.vacantShop.address,
                link:address+'?id='+this.$route.query.id+'&marketId='+that.common.marketInfo.id+'&cityId='+that.common.cityId, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                imgUrl:that.vacantShop.smallUrl,// 分享图标
                success:function(){
                    that.showIframe = false
                    util.showToast('已分享')
                }
            }
            wx.onMenuShareAppMessage(obj)
            wx.onMenuShareTimeline(obj)
          })
        } else {
          util.showToast(res.res.msg);
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
@import "../../assets/css/common.less";
.container {
    background: @colore;
    min-height:100vh;
}
.main{
    margin-bottom: 130px;
}
.swiper{
    width: 100%;
    height: 564px;
    background-color: #f5f5f5;
    position: relative;
}
.slider{
    width:100%;
    height: 564px;
}
.slide_image{
  width:100%;height:100%;
}
.image{
    width:100%;
    height:564px;
    display: block;
}
/* 头部信息 */
.head_mess {
    padding: 0 28px;
    background-color: #fff;
    margin-bottom: 14px;
    position: relative;
}
.head_price_Div{
   align-items: center;
  width: 490px;
  display: flex;
  // padding-left: 28px;
  // padding-right: 28px;
  padding-top: 20px;
  flex-direction: row;
}
.head_price_Div_text0{
  margin-top: 7px;
  height:40px;
  font-size:32px;
  font-weight:500;
  color:rgba(246,67,28,1);
  line-height:40px;

}
.head_price_Div_text1{
  height:60px;
  font-size:44px;
  font-weight:500;
  color:rgba(246,67,28,1);
  line-height:60px;
}
.head_price_Div_text_theme_3{
  color: #A88B2D;
}
.head_price_Div_text2{
  margin-top: 7px;
  margin-left: 10px;
  height:40px;
  font-size:24px;
  font-weight:400;
  color:rgba(153,153,153,1);
  line-height:40px;

}

.head_mess_title {
    padding: 2px 0 20px;
}

.head_mess_title_text {
    font-size: 36px;
    font-weight: bold;
    color: #333;
    line-height: 50px;
    max-width:490px;
}

.head_mess_labal {
    flex-direction: row;
    flex-wrap: wrap;
    width: 490px;
    margin-bottom: 28px;
}

.no_labal {
    margin-bottom: 70px;
}

.labal_item {
    height: 36px;
    background-color: rgba(235, 239, 245, 1);
    border-radius: 4px;
    padding: 0 8px;
    font-size: 24px;
    color: rgba(60, 100, 159, 1);
    line-height: 36px;
    margin-right: 10px;
    margin-bottom: 10px;
    display: inline-block;
}

.head_mess_address {
    display: flex;
    flex-direction: row;
    padding: 28px 0;
    .borderT();
}

.head_mess_address_icon {
    width: 28px;
    height: 28px;
    margin-top: 8px;
    margin-right: 14px;
}

.head_mess_address_text {
    flex: 1;
    font-size: 28px;
    color: rgba(51, 51, 51, 1);
    line-height: 44px;
}

.btn_duplicate {
    width: 44px;
    height: 44px;
    margin-left: 40px;
}
.fengxiangIcon{
  position:absolute;
  top: 20px;
  right: 28px;
  width: 44px;
  height: 44px;

}

.infoAbsoulte {
    position: absolute;
    top: 28px;
    right: 28px;
    width: 200px;
    height: 106px;
    border-radius: 8px;
    background-color: #FFFFFF;
    box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.04);
    .flex();
    flex-direction: column;
    align-items: center;
    justify-content: center;
}
.infoAbsoulte_text1 {
    font-size: 24px;
    line-height: 32px;
    color: #999999;
    text-align: center;
    margin-bottom: 4px;
}

.infoAbsoulte_text2 {
    font-size: 36px;
    line-height: 42px;
    color: #333333;
    font-weight: bold;
    text-align: center;
}


.tags {
    position: absolute;
    left: 0;
    bottom: 40px;
    height: 5px;
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
}

.tagsItem {
    width: 60px;
    height: 4px;
    background-color: #DADADA;
    border-radius: 2px;
    margin: 0 4px;
}

.tagsItemActive {
    background-color: rgba(0, 135, 255, 1)
}

.content_1 {
    padding: 28px;
    background-color: #ffffff;
    position: relative;
    min-height: 138px;
}

.content_1_line {
    height: 1px;
    background-color: #eaeaea;
    position: absolute;
    bottom: 0;
    left: 28px;
    right: 28px;
}

.info_text1 {
    height: 42px;
    text-align: left;
    color: #333333;
    line-height: 42px;
    font-size: 34px;
    margin-bottom: 14px;
}

.info_text2 {
    width: 400px;
    /* height: 34px; */
    text-align: left;
    color: #333333;
    line-height: 36px;
    font-size: 24px;
    margin-bottom: 14px;
}

.info_text_wrap {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
}

.info_text_wrap2 {
    min-height: 28px;
    width: 520px;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    flex-wrap: wrap;
}

.info_text3 {
    height: 36px;
    background-color: rgba(235, 239, 245, 1);
    border-radius: 4px;
    padding: 0 8px;
    font-size: 24px;
    color: rgba(60, 100, 159, 1);
    line-height: 36px;
    margin-right: 10px;
}

.frame_wrap {
    width: 1458px;
    display: flex;
    padding: 16px 21px;
    position: relative;
    flex-direction: row;
    align-items: stretch;
    background-color: #ffffff;
    transition: left 0.2s ease-in-out;
}

.frame_item {
    height: 32px;
    line-height: 32px;
    color: #999999;
    font-size: 24px;
    text-align: left;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-bottom: 24px;
}

.frame_item_1 {
    display: flex;
    flex-direction: row;
    flex: 1;
}

.frame_text1,
.frame_text2 {
    width: 168px;
    height: 32px;
    line-height: 32px;
    color: #999999;
    font-size: 24px;
    text-align: left;
}

.frame_text2 {
    color: #333333;
    font-size: 24px;
    line-height: 32px;
}

.content_3 {
    padding: 40px 28px;
    position: relative;
    margin-bottom: 14px;
    background-color: #ffffff;
}

.headePic {
    display: flex;
    flex-direction: row;
    justify-content: center;

}

.headePic_url {
    height: 68px;
    width: 68px;
    border-radius: 34px;
    margin: 0 6px;
    margin-bottom: 14px;
    background-color: #f5f5f5;
}

.content_3_text1 {
    height: 32px;
    line-height: 32px;
    color: #999999;
    font-size: 24px;
    text-align: center;
    width:100%;
}

.content_4 {
    padding: 36px 28px;
    margin-bottom: 14px;
    background-color: #ffffff;
}
.content_4_text1 {
    color: #333333;
    font-size: 28px;
    line-height: 34px;
    white-space: pre-line;
}

.btn {
    position: fixed;
    bottom: 0;
    left: 0;right:0;
    height: 76px;
    background-color: #ffffff;
    padding: 20px 28px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
}

.btnX {
    padding-bottom: 88px;
}

.btn_phone_wrap {
    width: 302px;
    display: flex;
    flex-direction: row;
}

.btn_phone_wrap_left {
    width: 76px;
    height: 76px;
    display: flex;
    flex-direction: row;
    border-radius: 38px;
    margin-right:20px;
    background-color: #eaeaea;
}
.btn_phone_wrap_right{
   flex:1;
   .flex();
   flex-direction: column;
   justify-content: center;
}

.wrap_right_text1,
.wrap_right_text2 {
    margin-bottom: 4px;
    height: 32px;
    text-align: left;
    font-size: 28px;
    color: #333333;
    line-height: 32px;
}

.wrap_right_text2 {
    font-size: 24px;
    color: #999999;
    margin:0;
}

.btn_text_wrap {
    width: 332px;
    border-radius: 4px;
    display: flex;
    flex-direction: row;
    background-color: @color17;
    justify-content: center;
    height: 68px;
    margin: 4px 0;
}

.btn_icon {
    width: 32px;
    height: 32px;
    margin-top: 18px;
    margin-right: 14px;
}
.btn_text_wrap_theme_3{
  border-radius: 8px;
  background-color: #333333;

}

.btn_text {
    color: #ffffff;
    height: 68px;
    font-size: 28px;
    text-align: center;
    line-height: 68px;
}
.btn_text_theme_3{
  color: #DFCBB0;

}

.content_2 {
    padding: 40px 28px 18px 28px;
    position: relative;
    background-color: #ffffff;
}

.content_info_title {
    height: 44px;
    text-align: left;
    line-height: 44px;
    margin-bottom: 32px;
    color: #333333;
    font-size: 32px;
}
/deep/ .swiper-pagination {
  color: #000;
  position: absolute;
  left: auto;
  right: 0.2rem;
  bottom: 0.2rem;
  display: inline-block;
  text-align: center;
  width: 0.92rem;
  height: 0.44rem;
  line-height: 0.44rem;
  color: #fff;
  font-size: 0.24rem;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 0.04rem;
  .swiper-pagination-current {
    // font-size: 0.28rem !important;
  }
}
</style>